var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('div',{staticClass:"menu-button",on:{"click":function($event){return _vm.clickMenu()}}}),_c('router-view'),_c('Footer'),_c('Menu',{ref:"menu"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }